import { ChartConstants } from "../shared/constants.js"
import { realZuChartX } from "./zeitachse.js"

const PHASENFARBEN = ["rgba(134, 146, 132, 0.12)", "rgba(134, 146, 132, 0.22)"]

function gruppierterJahresXWert(chart, jahr) {
	for (const serie of chart.series) {
		if (!Array.isArray(serie.xData) || serie.xData.length === 0) continue

		const xWert = serie.xData.find((x) => typeof x === "number" && new Date(x).getUTCFullYear() === jahr)
		if (xWert) return xWert
	}

	return Date.UTC(jahr, 0, 1)
}

function gruppierterChartXWert(chartKredit, chartX) {
	if (!chartKredit.chart || chartX == null) return chartX
	const jahr = new Date(chartX).getUTCFullYear()
	return gruppierterJahresXWert(chartKredit.chart, jahr)
}

function bewertungsPlotLines(chartKredit) {
	if (!chartKredit.chart) return

	const xAxis = chartKredit.chart.xAxis[0]
	const bewertungsdatum = chartKredit.data.bewertungsdatum
	const plotLines = Array.isArray(xAxis.options.plotLines) ? xAxis.options.plotLines : []
	const plotLine = plotLines.find((line) => line.id === "bewertungsplotline")
	const otherPlotLines = plotLines.filter((line) => line.id != "bewertungsplotline")

	if (!bewertungsdatum) return otherPlotLines

	const groupingAktiv = !!chartKredit.chart.options.plotOptions.series.dataGrouping.enabled
	const chartBewertungsdatum = realZuChartX(bewertungsdatum, chartKredit.data)
	const bewertungsjahr = new Date(chartBewertungsdatum).getUTCFullYear()
	const value = groupingAktiv ? gruppierterJahresXWert(chartKredit.chart, bewertungsjahr) : chartBewertungsdatum

	return [
		...otherPlotLines,
		{
			...(plotLine || {}),
			...buildBewertungsPlotline({ bewertungsdatum: chartBewertungsdatum, labelDatum: bewertungsdatum }),
			value: value,
		},
	]
}

function zinsbindungsPlotBands(chartKredit) {
	return buildZinsbindungsPlotBands(resolveZinsbindungsphasenForAxis(chartKredit))
}

export function buildBewertungsPlotline({ bewertungsdatum, labelDatum = bewertungsdatum }) {
	if (!bewertungsdatum) return null

	return {
		id: "bewertungsplotline",
		color: "#2F3435",
		width: 2,
		dashStyle: "longdashdot",
		zIndex: 10,
		bewertungsdatum: bewertungsdatum,
		value: bewertungsdatum,
		label: {
			text: `Aktuelle Bewertung<br>zum ${moment(new Date(labelDatum)).format("MM / YYYY")}`,
			rotation: 0,
			y: 15,
			x: 10,
			textAlign: "left",
			style: {
				color: ChartConstants.fontColorGrau,
				fontSize: ChartConstants.fontSizeMittel,
			},
		},
	}
}

export function initialeZinsbindungsphasen(chartData) {
	const phasen = Array.isArray(chartData?.zinsbindungsphasen) ? chartData.zinsbindungsphasen : []

	return phasen
		.map((phase, index) => ({
			...phase,
			from: index === 0 ? realZuChartX(chartData.startdatum, chartData) : realZuChartX(phase.from, chartData),
			to: realZuChartX(phase.to, chartData),
		}))
		.filter((phase) => phase?.from != null && phase?.to != null && phase.to > phase.from)
}

export function buildZinsbindungsPlotBands(phasen = []) {
	if (!Array.isArray(phasen)) return []

	return phasen
		.filter((phase) => phase?.from != null && phase?.to != null && phase?.label)
		.map((phase, index) => ({
			id: phase.id || `zinsbindungsphase-${index + 1}`,
			from: phase.from,
			to: phase.to,
			color: PHASENFARBEN[index % PHASENFARBEN.length],
			borderWidth: 1,
			borderColor: "rgba(134, 146, 132, 0.18)",
			zIndex: 0,
		}))
}

export function resolveZinsbindungsphasenForAxis(chartKredit) {
	const phasen = Array.isArray(chartKredit?.data?.zinsbindungsphasen) ? chartKredit.data.zinsbindungsphasen : []
	if (!chartKredit?.chart) return phasen

	const groupingAktiv = !!chartKredit.chart.options.plotOptions.series.dataGrouping.enabled

	return phasen
		.map((phase, index) => {
			const from = index === 0 ? realZuChartX(chartKredit.data.startdatum, chartKredit.data) : realZuChartX(phase.from, chartKredit.data)
			const to = realZuChartX(phase.to, chartKredit.data)
			if (!groupingAktiv) return { ...phase, from, to }

			return {
				...phase,
				from: index === 0 ? gruppierterChartXWert(chartKredit, realZuChartX(chartKredit.data.startdatum, chartKredit.data)) : gruppierterChartXWert(chartKredit, from),
				to: gruppierterChartXWert(chartKredit, to),
			}
		})
		.filter((phase) => phase?.from != null && phase?.to != null && phase.to > phase.from)
}

export function updateChartDekorationen(chartKredit) {
	if (!chartKredit.chart) return

	chartKredit.chart.xAxis[0].update({
		plotLines: bewertungsPlotLines(chartKredit),
		plotBands: zinsbindungsPlotBands(chartKredit),
	})
}
